module.exports = __webpack_public_path__ + "static/cicada_msg2-712e40b666b2bdb7460202e2b665b218.png";